export const CONVERT_GENERATED_EMAIL_FLAG =
  "convert_generated_profile_email";

const hasOwn = (object, key) =>
  Object.prototype.hasOwnProperty.call(object || {}, key);

export const normalizeProfileEmail = (email) =>
  typeof email === "string" ? email.trim().toLowerCase() : "";

export const isNoEmailProfile = (profile) => {
  if (!profile) {
    return false;
  }

  const generatedProfileFlag = hasOwn(profile, "genrated_profile")
    ? profile.genrated_profile
    : profile.generated_profile;

  return generatedProfileFlag === true || generatedProfileFlag === "true";
};

export const getProfileDisplayEmail = (profile) =>
  isNoEmailProfile(profile) ? "" : normalizeProfileEmail(profile?.email);

export const hasUsableProfileEmail = (profile) =>
  Boolean(getProfileDisplayEmail(profile));

/**
 * Profile APIs can contain profiles at several levels, including embedded
 * snapshots inside goals, events, clients, and products. Keep the generated
 * flag, but remove the storage-only email before the data reaches the UI.
 */
export const hideGeneratedProfileEmails = (value) => {
  if (Array.isArray(value)) {
    return value.map(hideGeneratedProfileEmails);
  }

  if (!value || typeof value !== "object") {
    return value;
  }

  const sanitizedValue = Object.keys(value).reduce((result, key) => {
    result[key] = hideGeneratedProfileEmails(value[key]);
    return result;
  }, {});

  if (isNoEmailProfile(value)) {
    sanitizedValue.email = "";
  }

  return sanitizedValue;
};

export const prepareProfileEmailUpdatePayload = (
  existingProfile,
  incomingPayload
) => {
  const updatePayload = { ...incomingPayload };

  delete updatePayload.generated_profile;
  delete updatePayload.genrated_profile;
  delete updatePayload[CONVERT_GENERATED_EMAIL_FLAG];

  if (!isNoEmailProfile(existingProfile) || !hasOwn(updatePayload, "email")) {
    return updatePayload;
  }

  const submittedEmail = normalizeProfileEmail(updatePayload.email);

  if (!submittedEmail) {
    delete updatePayload.email;
    return updatePayload;
  }

  updatePayload.email = submittedEmail;
  updatePayload[CONVERT_GENERATED_EMAIL_FLAG] = true;

  return updatePayload;
};
